export function recaudoPercentage(paid: number, total: number): number {
  if (!total || total <= 0) return 0;
  const raw = (paid / total) * 100;
  const clamped = Math.min(100, Math.max(0, raw));
  return Math.round(clamped * 10) / 10;
}

export interface InstallmentLike {
  dueDate: string | Date;
  paymentStatus: string;
  installmentNumber?: number;
}

export function nextDueInstallment<T extends InstallmentLike>(
  installments: T[] | null | undefined,
  today: Date = new Date(),
): T | null {
  if (!installments || installments.length === 0) return null;
  const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const candidates = installments
    .filter((i) => (i.paymentStatus ?? '').toUpperCase() !== 'PAID')
    .map((i) => ({ i, due: new Date(i.dueDate) }))
    .filter(({ due }) => !Number.isNaN(due.getTime()) && due >= todayStart)
    .sort((a, b) => a.due.getTime() - b.due.getTime());
  return candidates[0]?.i ?? null;
}

export interface ParticipantLike {
  status?: string;
}

export interface ActiveWithdrawnSummary {
  total: number;
  active: number;
  withdrawn: number;
  postponed: number;
}

export function activeVsWithdrawnSummary(
  participants: ParticipantLike[] | null | undefined,
): ActiveWithdrawnSummary {
  const summary: ActiveWithdrawnSummary = { total: 0, active: 0, withdrawn: 0, postponed: 0 };
  if (!participants) return summary;
  for (const p of participants) {
    summary.total += 1;
    const s = (p.status ?? '').toUpperCase();
    if (s === 'WITHDRAWN' || s === 'RETIRADA' || s === 'RETIRADO') summary.withdrawn += 1;
    else if (s === 'POSTPONED' || s === 'APLAZADA' || s === 'APLAZADO') summary.postponed += 1;
    else summary.active += 1;
  }
  return summary;
}
